import { forwardRef, Children, cloneElement, HTMLAttributes, ReactElement, CSSProperties } from 'react';
import { List, RowComponentProps } from 'react-window';

// Only custom data — react-window adds index/style/ariaAttributes automatically
type RowData = { items: ReactElement[] };

// Stable row renderer — defined outside to avoid reference churn
function RowRenderer({ index, style, items }: RowComponentProps<RowData>) {
  return cloneElement(items[index], { style: style as CSSProperties });
}

export function createVirtualizedListbox(itemSize: number) {
  return forwardRef<HTMLDivElement, HTMLAttributes<HTMLElement>>(function VirtualizedListbox(
    { children, ...other },
    ref
  ) {
    const items = Children.toArray(children) as ReactElement[];
    const itemCount = items.length;
    const height = Math.min(8, itemCount) * itemSize + 16;

    return (
      // Outer div holds the ref and all MUI listbox attrs (role, id, aria-*)
      <div ref={ref} {...other} style={{ height }}>
        <List
          rowComponent={RowRenderer}
          rowProps={{ items }}
          rowCount={itemCount}
          rowHeight={itemSize}
          style={{ height: '100%' }}
        />
      </div>
    );
  });
}

export const VirtualizedListbox = createVirtualizedListbox(72);
export const VirtualizedListboxLarge = createVirtualizedListbox(96);
